import { forwardRef, ForwardedRef } from 'react'

interface CheckboxProps {
  label? : string
  inputId? : string
  defaultChecked?: boolean
}

const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(({ label, inputId, defaultChecked, ...props }, ref: ForwardedRef<HTMLInputElement>) => (
  
    
  <div className='space-y-5'>
    <div className='flex gap-3 h-12 pl-2 mt-2.5 text-base items-center'>
      <div className='flex h-6 shrink-0 items-center'>
        <div className='group grid size-7 grid-cols-1'>
          <input
            id={inputId}
            ref={ref} 
            {...props}
            type='checkbox'
            aria-describedby={label}
            defaultChecked={defaultChecked}
            className='size-7 col-start-1 row-start-1 cursor-pointer appearance-none rounded-[4px] border border-[var(--checkbox-border)] bg-white checked:border-[var(--checkbox-active-bg)] checked:bg-[var(--checkbox-active-bg)] indeterminate:border-[var(--checkbox-active-bg)] indeterminate:bg-[var(--checkbox-active-bg)] focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--checkbox-active-bg)] disabled:border-gray-300 disabled:bg-gray-100 disabled:checked:bg-gray-100 forced-colors:appearance-auto'
          />
          <svg
            fill='none'
            viewBox='0 0 14 14'
            className='pointer-events-none col-start-1 row-start-1 size-6 self-center justify-self-center stroke-white group-has-disabled:stroke-gray-950/25'
          >
            <path
              d='M3 8L6 11L11 3.5'
              strokeWidth={1}
              strokeLinecap='round'
              strokeLinejoin='round'
              className='opacity-0 group-has-[:checked]:opacity-100'
            />
            <path
              d='M3 7H11'
              strokeWidth={1}
              strokeLinecap='round'
              strokeLinejoin='round'
              className='opacity-0 group-has-indeterminate:opacity-100'
            />
          </svg>
        </div>
      </div>
      <div>
        <label htmlFor={inputId} className='pt-0.5 cursor-pointer select-none'>
          {label}
        </label>
      </div>
    </div>
  </div>
  
))

export {Checkbox}
